<template>
 <div>
    <Teleport to="#settings-group-header">
      <T>Меню ресторана</T>
    </Teleport>  
    
    <MenuItemList :menu_categories="$store.getters.menu_categories" :modifier_schemes_map="$store.getters.menu_modifier_schemes_map" :menu_merged_items="$store.getters.menu_merged_items" :loading="loading"/>
  </div>
</template>

<script>
import MenuItemList from '../../components/settings/menu_item_list'
import Teleport from 'vue2-teleport'

export default {
  data: () => ({
    loading: true
  }),
  computed: {
    menu_item_ident(){
      return this.$route.params.arg || undefined
    },
    view(){
      return this.menu_item_ident ? 'MenuItem' : 'MainItemsList'
    }
  },
  async mounted(){
    this.loading = true

    try {
      await this.$store.dispatch('loadMenu')
    } finally {
      this.loading = false
    }
  },
  components: {
    Teleport,
    MenuItemList
  }
}
</script>